.root {
  display: flex;
  height: 100vh;
  overflow: hidden;
  background: var(--color-bg);
}

/* ── Sidebar ──────────────────────────────────────────────── */
.sidebar {
  width: 220px;
  min-width: 220px;
  background: var(--color-surface);
  border-right: 1px solid var(--color-border);
  display: flex;
  flex-direction: column;
  transition: width 0.25s ease, min-width 0.25s ease;
  overflow: hidden;
}

.collapsed .sidebar {
  width: 60px;
  min-width: 60px;
}

.brand {
  display: flex;
  align-items: center;
  gap: var(--sp-3);
  padding: var(--sp-5) var(--sp-4);
  border-bottom: 1px solid var(--color-border);
  height: 60px;
}

.brandIcon { flex-shrink: 0; }

.brandName {
  font-family: var(--font-mono);
  font-size: 15px;
  font-weight: 700;
  letter-spacing: 1.5px;
  background: var(--grad-brand);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  white-space: nowrap;
}

.nav {
  display: flex;
  flex-direction: column;
  gap: var(--sp-1);
  padding: var(--sp-4) var(--sp-3);
  flex: 1;
}

.navItem {
  display: flex;
  align-items: center;
  gap: var(--sp-3);
  padding: var(--sp-3) var(--sp-3);
  border-radius: var(--radius-md);
  color: var(--color-text-muted);
  font-family: var(--font-mono);
  font-size: 12.5px;
  font-weight: 500;
  letter-spacing: 0.5px;
  transition: background 0.15s, color 0.15s;
  white-space: nowrap;
  text-decoration: none;
}

.navItem:hover {
  background: rgba(56, 189, 248, 0.06);
  color: var(--color-text);
}

.navActive {
  background: rgba(56, 189, 248, 0.1) !important;
  color: var(--color-sky) !important;
  border: 1px solid rgba(56, 189, 248, 0.2);
}

.navIcon {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 20px;
}

.navLabel { overflow: hidden; }

/* ── Sidebar Footer ──────────────────────────────────────── */
.sidebarFooter {
  padding: var(--sp-4);
  border-top: 1px solid var(--color-border);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--sp-2);
}

.orgBadge {
  display: flex;
  align-items: center;
  gap: var(--sp-2);
  overflow: hidden;
  flex: 1;
}

.orgDot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: var(--color-success);
  flex-shrink: 0;
  animation: pulse-ring 2s ease infinite;
}

.orgName {
  font-family: var(--font-mono);
  font-size: 11px;
  color: var(--color-text-muted);
  letter-spacing: 0.3px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.collapseBtn {
  background: none;
  color: var(--color-text-muted);
  font-size: 18px;
  line-height: 1;
  padding: 2px 6px;
  border-radius: var(--radius-sm);
  transition: color 0.15s, background 0.15s;
  flex-shrink: 0;
}

.collapseBtn:hover {
  background: rgba(56, 189, 248, 0.08);
  color: var(--color-sky);
}

.helpBtn {
  background: none;
  border: none;
  color: var(--color-text-muted);
  line-height: 1;
  padding: 6px;
  border-radius: var(--radius-sm);
  cursor: pointer;
  display: inline-flex;
  transition: color 0.15s, background 0.15s;
}

.helpBtn:hover {
  background: rgba(56, 189, 248, 0.08);
  color: var(--color-sky);
}

/* ── Main ─────────────────────────────────────────────────── */
.main {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.topbar {
  height: 60px;
  border-bottom: 1px solid var(--color-border);
  padding: 0 var(--sp-6);
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: var(--color-surface);
}

.topbarLeft { display: flex; align-items: center; gap: var(--sp-4); }
.topbarRight { display: flex; align-items: center; gap: var(--sp-5); }

/* ── Tenant switcher (platform-admin) ────────────────────── */
.tenantSwitcher {
  font-family: var(--font-mono);
  font-size: 11px;
  padding: 5px 8px;
  border-radius: var(--radius-md);
  background: var(--color-surface);
  border: 1px solid var(--color-border-med);
  color: var(--color-text-muted);
  cursor: pointer;
  max-width: 180px;
  transition: border-color 0.15s, color 0.15s;
}
.tenantSwitcher:hover { border-color: var(--color-sky); color: var(--color-text); }
.tenantSwitcherActive {
  border-color: #f59e0b;
  color: #f59e0b;
  background: rgba(245, 158, 11, 0.08);
}

/* ── Admin impersonation banner ──────────────────────────── */
.adminBanner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px var(--sp-6);
  background: rgba(245, 158, 11, 0.1);
  border-bottom: 1px solid rgba(245, 158, 11, 0.25);
  font-family: var(--font-mono);
  font-size: 11px;
  color: #f59e0b;
  letter-spacing: 0.3px;
  flex-shrink: 0;
}
.adminBannerExit {
  font-family: var(--font-mono);
  font-size: 11px;
  color: #f59e0b;
  padding: 2px 8px;
  border: 1px solid rgba(245, 158, 11, 0.4);
  border-radius: var(--radius-sm);
  cursor: pointer;
  transition: background 0.15s;
}
.adminBannerExit:hover { background: rgba(245, 158, 11, 0.15); }

/* ── Org dot variant for admin mode ──────────────────────── */
.orgDotAdmin { background: #f59e0b !important; }

.breadcrumb {
  display: flex;
  align-items: center;
  gap: var(--sp-2);
  font-family: var(--font-mono);
  font-size: 13px;
  font-weight: 600;
  color: var(--color-text);
  letter-spacing: 0.5px;
}

.breadcrumbIcon { color: var(--color-sky); display: inline-flex; align-items: center; }

.syncStatus {
  display: flex;
  align-items: center;
  gap: var(--sp-2);
}

.syncDot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--color-success);
}

.syncLabel {
  font-family: var(--font-mono);
  font-size: 11px;
  color: var(--color-text-muted);
  letter-spacing: 0.5px;
}

.avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: linear-gradient(135deg, #0D9488, #38BDF8);
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: var(--font-mono);
  font-size: 11px;
  font-weight: 700;
  color: var(--color-bg);
  letter-spacing: 0.5px;
  cursor: pointer;
  border: none;
}

.userMenuWrap { position: relative; }

.userMenu {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  background: var(--color-surface);
  border: 1px solid var(--color-border-med);
  border-radius: var(--radius-md);
  box-shadow: 0 8px 24px rgba(0,0,0,0.4);
  min-width: 200px;
  z-index: 100;
  overflow: hidden;
}

.userMenuEmail {
  padding: var(--sp-3) var(--sp-4);
  font-size: 12px;
  color: var(--color-text-muted);
  border-bottom: 1px solid var(--color-border);
  word-break: break-all;
}

.userMenuSignOut {
  display: block;
  width: 100%;
  text-align: left;
  font-family: var(--font-mono);
  font-size: 12px;
  padding: var(--sp-3) var(--sp-4);
  background: transparent;
  border: none;
  color: var(--color-error, #f87171);
  cursor: pointer;
  transition: background 0.1s;
}
.userMenuSignOut:hover { background: rgba(239, 68, 68, 0.08); }

/* ── Floating action button ──────────────────────────────── */
.fab {
  position: fixed;
  bottom: 28px;
  right: 28px;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: var(--color-surface);
  border: 1px solid var(--color-border-med);
  color: var(--color-sky);
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.5), 0 0 0 1px rgba(56, 189, 248, 0.08);
  transition: right 0.25s ease, background 0.15s, box-shadow 0.15s, transform 0.15s;
  z-index: 200;
}

.fab:hover {
  background: rgba(56, 189, 248, 0.12);
  box-shadow: 0 4px 28px rgba(0, 0, 0, 0.55), 0 0 16px rgba(56, 189, 248, 0.18);
  transform: scale(1.08);
}

.fabActive {
  background: rgba(56, 189, 248, 0.14);
  border-color: rgba(56, 189, 248, 0.45);
  box-shadow: 0 4px 28px rgba(0, 0, 0, 0.55), 0 0 20px rgba(56, 189, 248, 0.22);
}

/* ── Body (page content + chat panel side by side) ───────── */
.body {
  flex: 1;
  display: flex;
  overflow: hidden;
}

.content {
  flex: 1;
  overflow-y: auto;
  padding: var(--sp-8);
}

.contentFlush {
  padding: 0;
  overflow: hidden;
}
